import React, { useState, useEffect } from "react";
import logoBlack from "../Assets/logoBlack.png";
import useStore from "../Store/useStore";
import Spinner from "../Components/Spinner/Spinner";
import { Outlet, useLocation, useNavigate } from "react-router-dom";
import useRequest from "../Hooks/useRequest";

const Products = () => {
  const { products, setProducts } = useStore();
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();
  const { pathname } = useLocation();
  const { request } = useRequest();

  useEffect(() => {
    if (products?.length < 1) {
      request({ url: "common/products" })
        .then(({ data }) => {
          setProducts(data);
          setLoading(false);
        })
        .catch(() => setLoading(false));
    } else {
      setLoading(false);
    }
  }, []);

  return (
    <div>
      {(pathname !== "/products" || loading) && (
        <div className="r-box h-14 md:h-24 flex items-center justify-start border-b">
          <img
            onClick={() => {
              navigate("/socialcard");
            }}
            className="cursor-pointer w-[130px] md:w-[185px]"
            src={logoBlack}
            alt=""
          />
        </div>
      )}

      {loading ? (
        <div>
          <div className="min-h-screen" />
          <div className="fixed top-0 left-0 inset-0 flex items-center justify-center">
            <Spinner />
          </div>
        </div>
      ) : (
        <div className={pathname === "/products" ? "min-h-screen" : "pt-14 pb-28 r-box"}>
          <Outlet />
        </div>
      )}
    </div>
  );
};

export default Products;
